<template>
    <div class="comment_wrap" v-loading="loading">
        <div
            @keydown="handleKeyDown"
            @keyup="handleKeyUp"
            contenteditable="true"
            ref="commentTextarea"
            id="commentTextarea"
            class="commentTextarea"
        ></div>
        <div class="commentImages">
            <ul>
                <li v-for="(item, key) in imageList" :key="key">
                    <i @click="handleClickDelImage(key)" class="iconfont icon-guanbi_dise"></i>
                    <img @click="handleClickPreview(item)" :src="item.file_path" alt="" />
                </li>
            </ul>
        </div>
        <div class="commentFiles">
            <ul>
                <li v-for="(item, key) in fileList" :key="key">
                    <p class="ellipsis" v-text="item.file_name"></p>
                    <div>
                        <span class="handle_icon_wrap" @click="handleClickPreview(item)">
                            <i class="iconfont icon-yanjing"></i>
                        </span>
                        <span class="handle_icon_wrap" @click="handleClickDelFile(key)">
                            <i class="iconfont icon-shanchu1"></i>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="commentHandle">
            <span class="handle_icon_wrap" @click="handleClickCommentUpload('fiel')">
                <i class="iconfont icon-lianjie"></i>
            </span>
            <span class="handle_icon_wrap" @click="handleClickCommentUpload('image')">
                <i class="iconfont icon-tupian"></i>
            </span>
        </div>

        <AtDialog
            :position="position"
            :queryString="queryString"
            :showDialog.sync="showDialog"
            v-if="showDialog"
            @onHide="handleHide"
            @onShow="handleShow"
            @onPickUser="handlePickUser"
        />
    </div>
</template>

<script>
import { uploadImg, getOSSData } from "@/utils/uploadOss";
import { formatFileSize ,getFileType} from "@/utils";
import AtDialog from "@/components/pComponents/AtDialog";
import { Dialog ,ImagePreview} from "vant";
export default {
    name: "mobileCommentComponent",
    components: {
        AtDialog,
    },
    props: {
        placeholderText: {
            type: String,
            return: "",
        },
    },
    data() {
        return {
            loading: false,
            showDialog: false, // 是否显示弹窗
            node: "", // 获取到节点
            endIndex: "", // 光标最后停留位置
            queryString: "", // 搜索值
            position: {
                x: 530,
                y: 300,
            }, // 弹窗显示位置
            imageList: [],
            fileList: [],
        };
    },
    computed: {},
    mounted() {
        this.placeholder();
    },

    methods: {
        // 预览
        handleClickPreview(file) {
            let file_type = getFileType(file.file_name)
            if (file_type.includes('image')) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$toast('当前文件格式不支持预览，请下载后查看')
                }
            }
        },
        handleClickCommentUpload(type) {
            let that = this;
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            // input.setAttribute('multiple', 'multiple')
            if (type == "image") {
                input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            } else {
                input.setAttribute("accept", "");
            }
            input.click();
            input.onchange = function () {
                const file = this.files[0];
                if (type == "image" && file.type.indexOf("image") < 0) {
                    that.$message.error("请上传图片文件！");
                    return false;
                }
                that.loading = true;
                if (file) {
                    uploadImg(file)
                        .then((res) => {
                            if (res.file_path) {
                                if (type == "image") {
                                    that.imageList.push({ file_name: res.file_name, file_path: res.file_path });
                                } else {
                                    res.file_size = formatFileSize(file.size);
                                    that.fileList.push({
                                        file_name: res.file_name,
                                        file_path: res.file_path,
                                        file_size: res.file_size,
                                    });
                                }
                            }
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                }
            };
        },
        handleClickDelImage(key) {
            this.imageList.splice(key, 1);
        },
        handleClickDelFile(key) {
            this.fileList.splice(key, 1);
        },
        placeholder() {
            this.$nextTick(() => {
                var div = document.getElementById("commentTextarea");
                div.setAttribute("data-placeholder", this.placeholderText);
                div.addEventListener("input", function () {
                    if (div.textContent.trim() === "") {
                        div.setAttribute("data-placeholder", this.placeholderText);
                    } else {
                        div.setAttribute("data-placeholder", "");
                    }
                });
            });
        },
        getCommentContent() {
            let commentText = this.$refs.commentTextarea.innerHTML;
            if (!commentText && this.imageList.length == 0 && this.fileList.length == 0)
                return this.$message.error("请输入内容！");
            const spanArr = this.$refs.commentTextarea.querySelectorAll(".at-button");

            const atPeople = [];
            const at_uid = [];
            if (spanArr.length > 0) {
                spanArr.forEach((item) => {
                    atPeople.push(JSON.parse(item.dataset.user));
                });
                atPeople.forEach((item, key) => {
                    at_uid.push(item.uid);
                });
            }
            return {
                content: commentText,
                img: this.imageList,
                files: this.fileList,
                at_uid: at_uid.join(","),
                at_people: atPeople,
            };
        },
        // 获取光标位置
        getCursorIndex() {
            const selection = window.getSelection();
            return selection.focusOffset; // 选择开始处 focusNode 的偏移量
        },

        // 获取节点
        getRangeNode() {
            const selection = window.getSelection();
            return selection.focusNode; // 选择的结束节点
        },

        // 弹窗出现的位置
        getRangeRect() {
            const selection = window.getSelection();
            const range = selection.getRangeAt(0); // 是用于管理选择范围的通用对象
            const rect = range.getClientRects()[0]; // 择一些文本并将获得所选文本的范围
            const LINE_HEIGHT = 30;
            return {
                x: rect.x,
                y: rect.y + LINE_HEIGHT,
            };
        },

        // 是否展示 @
        showAt() {
            const node = this.getRangeNode();
            if (!node || node.nodeType !== Node.TEXT_NODE) return false;
            const content = node.textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            return match && match.length === 2;
        },

        // 获取 @ 用户
        getAtUser() {
            const content = this.getRangeNode().textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            if (match && match.length === 2) {
                return match[1];
            }
            return undefined;
        },

        // 创建标签
        createAtButton(user) {
            const btn = document.createElement("span");
            btn.style.display = "inline-block";
            btn.dataset.user = JSON.stringify(user);
            btn.className = "at-button";
            btn.contentEditable = "false";
            btn.textContent = `@${user.name}`;
            btn.style.color = "#409eff";
            return btn;
        },

        replaceString(raw, replacer) {
            return raw.replace(/@([^@\s]*)$/, replacer);
        },

        // 插入@标签
        replaceAtUser(user) {
            const node = this.node;
            if (node && user) {
                const content = node.textContent || "";
                const endIndex = this.endIndex;
                const preSlice = this.replaceString(content.slice(0, endIndex), "");
                const restSlice = content.slice(endIndex);
                const parentNode = node.parentNode;
                const nextNode = node.nextSibling;
                const previousTextNode = new Text(preSlice);
                const nextTextNode = new Text("\u200b" + restSlice); // 添加 0 宽字符
                const atButton = this.createAtButton(user);
                parentNode.removeChild(node);
                // 插在文本框中
                if (nextNode) {
                    parentNode.insertBefore(previousTextNode, nextNode);
                    parentNode.insertBefore(atButton, nextNode);
                    parentNode.insertBefore(nextTextNode, nextNode);
                } else {
                    parentNode.appendChild(previousTextNode);
                    parentNode.appendChild(atButton);
                    parentNode.appendChild(nextTextNode);
                }
                // 重置光标的位置
                const range = new Range();
                const selection = window.getSelection();
                range.setStart(nextTextNode, 0);
                range.setEnd(nextTextNode, 0);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },

        // 键盘抬起事件
        handleKeyUp() {
            if (this.showAt()) {
                const node = this.getRangeNode();
                const endIndex = this.getCursorIndex();
                this.node = node;
                this.endIndex = endIndex;
                this.position = this.getRangeRect();
                this.queryString = this.getAtUser() || "";
                this.showDialog = true;
            } else {
                this.showDialog = false;
            }
        },

        // 键盘按下事件
        handleKeyDown(e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                const br = document.createElement("br");
                range.insertNode(br);
                range.setStartAfter(br);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            if (this.showDialog) {
                if (e.code === "ArrowUp" || e.code === "ArrowDown" || e.code === "Enter") {
                    e.preventDefault();
                }
            }
        },

        // 插入标签后隐藏选择框
        handlePickUser(user) {
            this.replaceAtUser(user);
            this.user = user;
            this.showDialog = false;
        },
        // 隐藏选择框
        handleHide() {
            this.showDialog = false;
        },

        // 显示选择框
        handleShow() {
            this.showDialog = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.comment_wrap {
    min-height: 138px;
    height: 100%;
    border-radius: 2px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .commentTextarea {
        flex: 1;
        width: 100%;
        // height: 84px;
        display: block;
        padding: 6px 12px;
        line-height: 1.5;
        box-sizing: border-box;
        color: #606266;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        overflow-y: scroll;
        position: relative;
        &::before {
            content: attr(data-placeholder);
            position: absolute;
            top: 7px;
            left: 14px;
            color: gray;
            pointer-events: none;
        }
    }
    .commentImages {
        width: 100%;
        ul {
            display: flex;
            flex-wrap: wrap;
            padding: 0 12px;
            height: 40px;
            overflow: auto;
            li {
                width: 32px;
                margin-right: 8px;
                position: relative;
                margin-bottom: 8px;
                img {
                    display: block;
                    width: 32px;
                    height: 32px;
                    border-radius: 4px;
                    object-fit: contain;
                }
                i {
                    position: absolute;
                    font-size: 12px;
                    right: 1px;
                    top: 1px;
                    cursor: pointer;
                    color: rgba(191, 191, 191, 1);
                }
            }
        }
    }
    .commentFiles {
        width: 100%;
        ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 0 12px;
            height: 26px;
            overflow: auto;
            li {
                width: calc(50% - 4px);
                margin-bottom: 4px;
                border-radius: 2px;
                background: rgba(249, 249, 249, 1);
                border: 1px solid rgba(217, 217, 217, 1);
                line-height: 20px;
                height: 22px;
                padding: 0 8px;
                box-sizing: border-box;
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p {
                    font-size: 12px;
                    color: rgba(102, 102, 102, 1);
                    width: calc(100% - 50px);
                }
                div {
                    width: 40px;
                    display: flex;
                    justify-content: space-between;
                    span.handle_icon_wrap {
                        width: 16px;
                        height: 16px;
                        font-size: 12px;
                        line-height: 16px;
                        i {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
    }
    .commentHandle {
        padding: 4px 12px 8px;
        box-sizing: border-box;
        text-align: right;
        span {
            margin-left: 8px;
        }
    }
}
</style>
